import React from 'react';
import { Modal, ConfirmModal } from '../../../../components';
import { PresentationForm } from './PresentationForm';
import { ViewPresentationModal } from './ViewPresentationModal';
import { PRESENTATION_LABELS } from '../constants';
import type { BriefPresentatiionDto } from '../../../../services/presentations-management/models/BriefPresentatiionDto';
import type { PresentationDto } from '../../../../services/presentations-management/models/PresentationDto';
import type { PresentationFormData } from '../types';

interface PresentationModalsProps {
  isOpened: boolean;
  onClose: () => void;
  isOpenedEditModal: boolean;
  onCloseEditModal: () => void;
  isOpenedDeleteModal: boolean;
  onCloseDeleteModal: () => void;
  isOpenedViewModal: boolean;
  onCloseViewModal: () => void;
  selectedPresentation: BriefPresentatiionDto | null;
  presentationDetails: PresentationDto | null;
  handleCreatePresentationSubmit: (data: PresentationFormData) => void;
  handleEditPresentationSubmit: (data: PresentationFormData) => void;
  handleConfirmDelete: () => void;
  creatingPresentation: boolean;
  updatingPresentation: boolean;
  deletingPresentation: boolean;
  loadingDetails: boolean;
}

export const PresentationModals: React.FC<PresentationModalsProps> = ({
  isOpened,
  onClose,
  isOpenedEditModal,
  onCloseEditModal,
  isOpenedDeleteModal,
  onCloseDeleteModal,
  isOpenedViewModal,
  onCloseViewModal,
  selectedPresentation,
  presentationDetails,
  handleCreatePresentationSubmit,
  handleEditPresentationSubmit,
  handleConfirmDelete,
  creatingPresentation,
  updatingPresentation,
  deletingPresentation,
  loadingDetails,
}) => {
  return (
    <>
      <Modal
        size="small"
        open={isOpened}
        onClose={onClose}
        title={PRESENTATION_LABELS.CREATE_PRESENTATION}
      >
        <PresentationForm
          onSave={handleCreatePresentationSubmit}
          onCancel={onClose}
          loading={creatingPresentation}
        />
      </Modal>

      <Modal
        size="small"
        open={isOpenedEditModal}
        onClose={onCloseEditModal}
        title={PRESENTATION_LABELS.EDIT_PRESENTATION}
      >
        <PresentationForm
          presentation={selectedPresentation}
          onSave={handleEditPresentationSubmit}
          onCancel={onCloseEditModal}
          loading={updatingPresentation}
        />
      </Modal>

      <ConfirmModal
        title={PRESENTATION_LABELS.DELETE_PRESENTATION}
        open={isOpenedDeleteModal}
        onClose={onCloseDeleteModal}
        onConfirm={handleConfirmDelete}
        confirmButtonLabel="Delete"
        confirmButtonClassName="w-full bg-dangerSecondary hover:bg-danger border border-dangerSecondary text-contrast"
        saving={deletingPresentation}
      >
        <p className="text-medium">{PRESENTATION_LABELS.DELETE_CONFIRMATION}</p>
      </ConfirmModal>

      <ViewPresentationModal
        open={isOpenedViewModal}
        onClose={onCloseViewModal}
        presentation={presentationDetails}
        loading={loadingDetails}
      />
    </>
  );
};
